<div class="mx-auto max-w-3xl pb-6">
  <h1 class="text-[1.75rem] font-bold leading-relaxed">{{ 'profile.headline' | transloco }}</h1>
  @if (isPropoints()) {
    <div class="mt-4">{{ 'profile.connectedToPropoints' | transloco }}</div>
  }
  @if (successMessage()) {
    <p class="mt-6 rounded-lg border border-primary-500 bg-primary-50 px-6 py-4">
      {{ 'profile.subscription.purchaseSuccessMessage' | transloco }}
    </p>
  }

  <app-profile-data class="mt-12 block" [user]="user" [loading]="loading()" (onChange)="onChange($event)" />

  <app-profile-subscription class="mt-16 block" [user]="user" [loading]="loading()" (onChange)="onChangeSubscription($event)" />
</div>
